import { FaInfoCircle } from "react-icons/all";
import BadgeButton from "@core/buttons/electrons/BadgeButton";
import { Collapse } from "react-collapse/lib/Collapse";
import React, { useEffect, useRef, useState } from "react";
import PreOrderForm from "@components/Product/ProductForm/PreOrderForm";
import { formatAmount } from "@utils/helpers";

const ProductPlan = ({
  product,
  total,
  saveAmount,
  lowestInstallment,
  plans,
  selectedPlan,
  selectedColor,
  selectedMemory,
  onPlanSelect,
  selectedTimeline,
  onTimelineSelect,
  selectedInstallment,
  onInstallmentSelect,
  step,
  setStep,
  cities,
}) => {
  const myRef = useRef(null);
  const [paymentType, setPaymentType] = useState(null);
  const [selectedInstallmentPlan, setSelectedInstallmentPlan] = useState("");
  const [installments, setInstallments] = useState([]);

  useEffect(() => {
    setSelectedInstallmentPlan("");
    setInstallments([]);
  }, [selectedMemory, paymentType]);

  useEffect(() => {
    console.log("installment");
    console.log("selectedMemory:", selectedMemory);
    console.log("selectedInstallment:", selectedInstallment);
  }, [selectedMemory, selectedInstallment]);

  useEffect(() => {
    console.log("plans:", plans);
  }, [plans]);

  return (
    <div className="flex flex-col justify-center">
      <div
        className={`flex justify-center ${
          product.availability_status === "info"
            ? "bg-gray-100"
            : "bg-brand-error"
        } rounded-lg px-5 py-4 md:px-12 md:py-8 mb-6 md:mb-12`}
      >
        <div className="flex-col mx-auto">
          <FaInfoCircle className="text-2xl mx-auto 3xl:flex-start mb-3" />
          <div
            className={`text-base md:text-lg font-sans leading-4 px-4 xl:px-40 text-center mt-2 ${
              product.availability_status === "info"
                ? "text-gray-800"
                : "text-white"
            }`}
          >
            {product.availability_message}
          </div>
        </div>
      </div>
      <div className="grid grid-cols-2 gap-2 md:flex mb-4">
        <BadgeButton
          lg
          selected={paymentType === "only-phone"}
          title={"Çmim i Plotë"}
          deal={`${formatAmount(total)} Lekë`}
          onClick={() => {
            onPlanSelect(null);
            setPaymentType("only-phone");
            onTimelineSelect(null);
            setStep("registration");
            myRef.current.scrollIntoView({
              behavior: "smooth",
              block: "center",
            });
          }}
        />
        <BadgeButton
          lg
          selected={paymentType === "with-installment"}
          title={"Me këste"}
          description={"Kombinuar me plan"}
          // deal={`Duke nisur nga ${formatAmount(total)} Lekë`}
          onClick={() => {
            setPaymentType("with-installment");
            setStep("pre-order");
            myRef.current.scrollIntoView({
              behavior: "smooth",
              block: "center",
            });
          }}
        />
        {/* <BadgeButton
          lg
          selected={paymentType === "with-plan"}
          title={`Përfito me ulje`}
          description={"Kombinuar me plan"}
          deal={`Deri në ${formatAmount(saveAmount)} Lekë ulje`}
          onClick={() => {
            setPaymentType("with-plan");
            setStep("pre-order");
            myRef.current.scrollIntoView({
              behavior: "smooth",
              block: "center",
            });
          }}
        /> */}
      </div>
      <Collapse isOpened={paymentType === "with-installment"}>
        <hr className="mt-8 mb-4" />
        <div className="font-bold text-lg text-gray-700 font-sans tracking-tight mb-4 text-center md:text-left">
          Zgjidh Planin
        </div>
        <div className="grid grid-cols-2 gap-2 md:flex mb-4">
          {selectedMemory?.installments &&
            Object.keys(selectedMemory.installments).map((plan) => (
              <BadgeButton
                key={plan}
                lg
                selected={plan === selectedInstallmentPlan}
                description={plan}
                descriptionFont={"font-semibold"}
                onClick={() => {
                  setSelectedInstallmentPlan(plan);
                  setInstallments(selectedMemory?.installments[plan]);
                  myRef.current.scrollIntoView({
                    behavior: "smooth",
                    block: "center",
                  });
                }}
              />
            ))}
          <div ref={myRef} />
        </div>
        <Collapse isOpened={!!selectedInstallmentPlan}>
          <hr className="mt-8 mb-4" />
          <div className="font-bold text-lg text-gray-700 font-sans tracking-tight mb-4 text-center md:text-left">
            Zgjidh kohëzgjatjen e kontratës
          </div>
          <div className="grid grid-cols-2 gap-2 md:flex mb-4">
            {installments?.map((installment) => (
              <BadgeButton
                lg
                selected={installment.id === selectedInstallment?.id}
                title={installment.timeline_name}
                // description={
                //   installment.prepay_amount
                //     ? `Parapagesë ${formatAmount(
                //         installment.prepay_amount
                //       )} Lekë`
                //     : ""
                // }
                deal={`${formatAmount(
                  installment.amount /
                    parseInt(
                      installment.timeline_name.replace(/\D/g, "") || "1"
                    )
                )} Lekë/Muaj`}
                margin={"mr-2 md:mr-5"}
                onClick={() => {
                  onInstallmentSelect(installment);
                  setStep("registration");
                  myRef.current.scrollIntoView({
                    behavior: "smooth",
                    block: "center",
                  });
                }}
              />
            ))}

            <div ref={myRef} />
          </div>
        </Collapse>
      </Collapse>
      <Collapse isOpened={paymentType === "with-plan"}>
        <hr className="mt-8 mb-4" />
        <div className="font-bold text-lg text-gray-700 font-sans tracking-tight mb-4 text-center md:text-left">
          Zgjidh Planin
        </div>
        <div className="grid grid-cols-2 gap-2 md:flex mb-4">
          {plans.map((plan) => (
            <BadgeButton
              key={plan.id}
              sm
              selected={plan.id === selectedPlan?.id}
              description={plan.name}
              width={"lg:w-1/3"}
              descriptionFont={"font-semibold"}
              onClick={() => {
                onPlanSelect(plan);
                myRef.current.scrollIntoView({
                  behavior: "smooth",
                  block: "center",
                });
              }}
            />
          ))}
          <div ref={myRef} />
        </div>
        <Collapse isOpened={selectedPlan !== null}>
          <hr className="mt-8 mb-4" />
          <div className="font-bold text-lg text-gray-700 font-sans tracking-tight mb-4 text-center md:text-left">
            Zgjidh kohëzgjatjen e kontratës
          </div>
          <div className="grid grid-cols-2 gap-2 md:flex mb-4">
            {selectedPlan?.timelines?.map((timeline) => (
              <BadgeButton
                lg
                selected={timeline.id === selectedTimeline?.id}
                title={timeline.name}
                description={`${formatAmount(
                  total - Number(timeline?.save_amount || 0)
                )} Lekë`}
                deal={`Kurse ${formatAmount(timeline.save_amount)} Lekë`}
                margin={"mr-2 md:mr-5"}
                onClick={() => {
                  onTimelineSelect(timeline);
                  setStep("registration");
                  myRef.current.scrollIntoView({
                    behavior: "smooth",
                    block: "center",
                  });
                }}
              />
            ))}
            <div ref={myRef} />
          </div>
        </Collapse>
      </Collapse>
      <Collapse isOpened={step === "registration"}>
        <PreOrderForm
          ref={myRef}
          saveAmount={saveAmount}
          product={product}
          selectedColor={selectedColor}
          selectedMemory={selectedMemory}
          selectedTimeline={selectedTimeline}
          selectedInstallment={selectedInstallment}
          cities={cities}
          paymentType={paymentType}
          setPaymentType={setPaymentType}
          setStep={setStep}
          step={step}
        />
      </Collapse>
    </div>
  );
};
export default ProductPlan;
